import React from 'react';

import { MainEquipmentList } from 'lib/equipments';

import { FadeUp } from 'components/organisms';

import s from '../../styles/organisms/equipment.module.scss';
import classNames from 'classnames';

export const Equipment: React.FC = () => {
  return (
    <div className={s.equipmentWrapper}>
      <FadeUp>
        <p className={s.balloon}>ペットのためのお部屋内・共用部の設備</p>
        <div className={s.contents}>
          <div className={s.mainList}>
            {MainEquipmentList.map((item, index) => (
              <div className={s.mainItem} key={index}>
                <img src={require(`assets/images/${item.image}`)} alt={item.name} />
                <p>{item.name}</p>
              </div>
            ))}
          </div>

        </div>
        <p className={classNames(s.note)}>※ 事業化に向け現在検討中の設備内容です</p>
      </FadeUp>
    </div>
  );
};
